import type { ImsUnitQuotationPlans, MonthlyPaymentsAndAddition } from '@/server/api/buyer-front/types'

export const calculateDownPayment = (initialFeePrice: number, separationPrice: number): number => {
  return initialFeePrice + separationPrice
}

export const getMonthlyPayments = (monthlyPaymentsAndAdditions: MonthlyPaymentsAndAddition[] = []): MonthlyPaymentsAndAddition[] => {
  return monthlyPaymentsAndAdditions.filter(item => item.type === 'monthly_payment')
}

export const getSeparationPaymentsAndAdditions = (quotationPlan: ImsUnitQuotationPlans): MonthlyPaymentsAndAddition[] => {
  return quotationPlan.monthly_payments_and_additions.filter(item => [item.is_separation, item.is_separation_addition, item.is_reservation_fee].includes(true))
}
